import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_AUTOCOMPLETE_URL, BASE_URL } from '../apiConfig';

export const fetchDelegateApprovalAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-delegate-approval`,
    payload,
  );
  return response;
};

export const fetchEmployeesAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-employees`,
    payload,
  );
  return response;
};

export const fetchPickListDetailsAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-picklist-details`,
    payload,
  );
  return response;
};

export const fetchLeaveAndActualDaysAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-leave-actual-days`,
    payload,
  );
  return response;
};

export const fetchEmployeesByRolesAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-employees-by-roles`,
    payload,
  );
  return response;
};

export const fetchTravelCountry = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/travel-country`,
    payload,
  );
  return response;
};

export const fetchTravelFromCity = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/travel-from-city`,
    payload,
  );
  return response;
};

export const fetchTravelToCity = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/travel-to-city`,
    payload,
  );
  return response;
};

export const fetchTravelAirLine = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/travel-airLine`,
    payload,
  );
  return response;
};

export const fetchTravelStatus = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/travel-status`,
    payload,
  );
  return response;
};

export const fetchDynamicData = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/dynamic-data`,
    payload,
  );
  return response;
};

export const fetchClassification = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/classification`,
    payload,
  );
  return response;
};

export const fetchEmployeeLocation = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/employee-location`,
    payload,
  );
  return response;
};

export const fetchEmployeeSearchAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/employee-search`,
    payload,
  );
  return response;
};
